<template>
  <div id="app">
    <router-view />
    <TabBar v-if="showTabBar" />
    <Dialog
      :visible="dialogConfig.visible"
      :title="dialogConfig.title"
      :message="dialogConfig.message"
      :icon="dialogConfig.icon"
      :show-cancel="dialogConfig.showCancel"
      :cancel-text="dialogConfig.cancelText"
      :confirm-text="dialogConfig.confirmText"
      :confirm-type="dialogConfig.confirmType"
      @confirm="handleDialogConfirm"
      @cancel="handleDialogCancel"
    />
  </div>
</template>

<script>
import { recordError, recordPageLoad } from '@/utils/performance'
import { safeLog } from '@/utils/security'
import { setDialogInstance } from '@/utils/dialog'
import TabBar from '@/components/TabBar.vue'
import Dialog from '@/components/Dialog.vue'

export default {
  name: 'App',
  components: {
    TabBar,
    Dialog
  },
  data() {
    return {
      dialogConfig: {
        visible: false,
        title: '',
        message: '',
        icon: 'info',
        showCancel: false,
        cancelText: '取消',
        confirmText: '确定',
        confirmType: 'primary',
        onConfirm: null,
        onCancel: null
      }
    }
  },
  computed: {
    showTabBar() {
      const tabBarPages = ['/index', '/borrow', '/info', '/my']
      return tabBarPages.includes(this.$route.path)
    }
  },
  created() {
    recordPageLoad()
    this.setupGlobalErrorHandlers()
    safeLog('App launched')
    setDialogInstance(this)
  },
  methods: {
    setupGlobalErrorHandlers() {
      if (typeof window !== 'undefined') {
        window.onerror = (message, source, lineno, colno, error) => {
          recordError(error || message, 'Global JS Error')
          safeLog('Global JS Error:', { message, source, lineno, colno })
          return false
        }
        
        window.addEventListener('unhandledrejection', (event) => {
          recordError(event.reason, 'Unhandled Promise Rejection')
          safeLog('Unhandled Promise Rejection:', event.reason)
        })
      }
    },
    showDialog(config) {
      this.dialogConfig = {
        visible: true,
        title: '',
        message: '',
        icon: 'info',
        showCancel: false,
        cancelText: '取消',
        confirmText: '确定',
        confirmType: 'primary',
        onConfirm: null,
        onCancel: null,
        ...config
      }
    },
    hideDialog() {
      this.dialogConfig.visible = false
    },
    handleDialogConfirm() {
      if (this.dialogConfig.onConfirm) {
        this.dialogConfig.onConfirm()
      }
    },
    handleDialogCancel() {
      if (this.dialogConfig.onCancel) {
        this.dialogConfig.onCancel()
      }
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}

html, body {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  position: relative;
}

body {
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: manipulation;
}

#app {
  min-height: 100vh;
  padding-bottom: env(safe-area-inset-bottom);
}

button, input, textarea {
  font-family: inherit;
  -webkit-appearance: none;
  outline: none;
}

img {
  max-width: 100%;
  vertical-align: middle;
}
</style>
